/* eslint-disable import/no-duplicates */

import { useIntl } from 'react-intl';
import { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr-CA'; // TODO: re-evaluates use of date-fns locales once it supports the Int'l API.
import en from 'date-fns/locale/en-CA'; // TODO: re-evaluates use of date-fns locales once it supports the Int'l API.
import enUS from 'date-fns/locale/en-US'; // TODO: re-evaluates use of date-fns locales once it supports the Int'l API.

import MaybeTranslation from 'components/MaybeTranslation';
import { StyledDatePicker, LabelContainer } from './styles';

import { DatePickerField } from 'components/FormField';
import { ifInTestingMode } from 'utils/tests.utils';

registerLocale('fr-CA', fr);
registerLocale('en-CA', en);
registerLocale('en-US', enUS);

const CustomDatePicker = ({
  selected,
  setSelected,
  name,
  label,
  readOnly,
  padding,
  callToActionButton,
  dateFormat,
  error,
  onBlur,
  ...rest
}) => {
  const intl = useIntl();

  return (
    <StyledDatePicker data-testid={ifInTestingMode('CustomDatePicker')} className={error ? 'error field' : ''}>
      <LabelContainer>
        {label && (
          <label htmlFor={name}>
            <MaybeTranslation renderedValue={label} />
          </label>
        )}
        {callToActionButton != undefined && callToActionButton}
      </LabelContainer>
      <DatePickerField
        {...rest}
        onBlur={onBlur}
        name={name}
        value={selected?.toISOString()}
        onChange={(e) => setSelected(new Date(e.target.value))}
        errored={Boolean(error)}
        readOnly={readOnly}
        locale={intl.locale}
        showTimeSelect
        disabledKeyboardNavigation
      />
    </StyledDatePicker>
  );
};

export default CustomDatePicker;
